const locales = [
    {
        iso3166: "AR",
        icu: "es-AR",
    },
    {
        iso3166: "CL",
        icu: "es-CL",
    },
    {
        iso3166: "CO",
        icu: "es-CO",
    },
    {
        iso3166: "BR",
        icu: "pt-BR",
    },
];
/*
  Transcode locale string from one format to another.
*/
export default function transcodeLocale(locale, fromFormat, toFormat) {
    const localeObject = locales.find((item) => {
        return item[fromFormat] === locale;
    });
    return localeObject ? localeObject[toFormat] : "UNKNOWN";
}
//# sourceMappingURL=transcode-locale.js.map